import { createContext } from 'react';

import { SmsBillingFilters } from '../../core/portal/pages/sms/billing/interfaces';
import { UssdBillingFilters } from '../../core/portal/pages/ussd/billing/interfaces';
import { PayoutBillingFilters } from '../../core/portal/pages/payout/billing/interfaces';
import { OnDemandBillingFilters } from '../../core/portal/pages/ondemand/billing/interfaces';
import { CustomerValidationBillingFilters } from '../../core/portal/pages/kyc/billing/interfaces';
import { AirtimeBillingFilters } from '../../core/portal/pages/airtime-and-data/billing/interfaces';
import { OperatorLookupBillingFilters } from '../../core/portal/pages/operator-lookup/billing/interfaces';
import { MerchantPaymentBillingFilters } from '../../core/portal/pages/merchant-payment/billing/interfaces';
import { AccountTransfersBillingFilters } from '../../core/portal/pages/account-transfers/billing/interfaces';
// eslint-disable-next-line max-len
import { CustomerAuthenticationBillingFilters } from '../../core/portal/pages/customer-authentication/billing/interfaces';
import { CustomerEnrollmentBillingFilters } from '../../core/portal/pages/customer-enrollment/billing/interfaces';
import { WapBillingFilters } from '../../core/portal/pages/wap/billing/interfaces';
import { VoiceBillingFilters } from '../../core/portal/pages/voice/billing/interfaces';

export type AllFilters =
  | UssdBillingFilters
  | WapBillingFilters
  | VoiceBillingFilters
  | SmsBillingFilters
  | OperatorLookupBillingFilters
  | AirtimeBillingFilters
  | AccountTransfersBillingFilters
  | OnDemandBillingFilters
  | PayoutBillingFilters
  | CustomerAuthenticationBillingFilters
  | CustomerEnrollmentBillingFilters
  | MerchantPaymentBillingFilters
  | CustomerValidationBillingFilters;

export interface UpdateFiltersProps {
  filtersToUpdatePath: FILTERS_PATH;
  newFilters: AllFilters;
}
export enum FILTERS_PATH {
  VOICE_BILLING_PATH = 'voice',
  WAP_BILLING_PATH = 'wap',
  USSD_BILLING_PATH = 'ussd',
  SMS_BILLING_PATH = 'sms',
  OPERATOR_LOOKUP_BILLING_PATH = 'operatorLookup',
  AIRTIME_BILLING_PATH = 'airtime',
  ACCOUNT_TRANSFERS_BILLING_PATH = 'accountTransfers',
  ONDEMAND_BILLING_PATH = 'ondemand',
  PAYOUT_BILLING_PATH = 'payout',
  MERCHANT_PAYMENT_BILLING_PATH = 'merchantPayment',
  CUSTOMER_VALIDATION_BILLING_PATH = 'kyc',
  CUSTOMER_AUTHENTICATION_BILLING_PATH = 'customerAuthentication',
  CUSTOMER_ENROLLMENT_BILLING_PATH = 'customerEnrollment'
}
export interface FiltersValues {
  [FILTERS_PATH.VOICE_BILLING_PATH]: {
    billing: VoiceBillingFilters;
  };
  [FILTERS_PATH.WAP_BILLING_PATH]: {
    billing: WapBillingFilters;
  };
  [FILTERS_PATH.USSD_BILLING_PATH]: {
    billing: UssdBillingFilters;
  };
  [FILTERS_PATH.SMS_BILLING_PATH]: {
    billing: SmsBillingFilters;
  };
  [FILTERS_PATH.OPERATOR_LOOKUP_BILLING_PATH]: {
    billing: OperatorLookupBillingFilters;
  };
  [FILTERS_PATH.AIRTIME_BILLING_PATH]: {
    billing: AirtimeBillingFilters;
  };
  [FILTERS_PATH.ACCOUNT_TRANSFERS_BILLING_PATH]: {
    billing: AccountTransfersBillingFilters;
  };
  [FILTERS_PATH.ONDEMAND_BILLING_PATH]: {
    billing: OnDemandBillingFilters;
  };
  [FILTERS_PATH.PAYOUT_BILLING_PATH]: {
    billing: PayoutBillingFilters;
  };
  [FILTERS_PATH.MERCHANT_PAYMENT_BILLING_PATH]: {
    billing: MerchantPaymentBillingFilters;
  };
  [FILTERS_PATH.CUSTOMER_VALIDATION_BILLING_PATH]: {
    billing: CustomerValidationBillingFilters;
  };
  [FILTERS_PATH.CUSTOMER_AUTHENTICATION_BILLING_PATH]: {
    billing: CustomerAuthenticationBillingFilters;
  };
  [FILTERS_PATH.CUSTOMER_ENROLLMENT_BILLING_PATH]: {
    billing: CustomerEnrollmentBillingFilters;
  };
}

export interface FiltersContextProps {
  filtersValues: FiltersValues;
  handleUpdateFilters: (props: UpdateFiltersProps) => void;
}

export const FiltersContext = createContext<FiltersContextProps>({} as FiltersContextProps);
